export default __webpack_public_path__ + "static/media/Vellore-Diocese.2176b07b.png";